import FJAIAudioLeft from '../view/FJAIAudioLeft.jsx';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionAIAudioGenerator from '../../../../redux/action/FJActionAIAudioGenerator.js';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon.js';
import { setSliceIsDraggingVoiceFile } from '../../../../redux/slices/FJSliceAIAudioGenerator.js';
import FJActionModal from '../../../../redux/action/FJActionModal.js';
import FJAudioPlayManager from '../../../../store/FJAudioPlayManager.js';
import { useMemo, useEffect } from 'react';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const FJAIAudioLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const tabIndex = useSelector(state => state.AIAudioGenerator.tabIndex);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const creditNumber = useSelector(state => state.common.creditNumber);

    const musicFreeNum = useSelector(state => state.AIAudioGenerator.musicFreeNum);
    const intFreeNum = useSelector(state => state.AIAudioGenerator.intFreeNum);
    const sfxFreeNum = useSelector(state => state.AIAudioGenerator.sfxFreeNum);

    const freeNumCreation = useMemo(() => {
        if (tabIndex === 0) {
            return musicFreeNum;
        } else if (tabIndex === 1) {
            return intFreeNum;
        } else if (tabIndex === 2) {
            return sfxFreeNum;
        }
    }, [tabIndex, musicFreeNum, intFreeNum, sfxFreeNum]);

    const audioInfo = useSelector(state => state.AIAudioGenerator.audioInfo);
    const uploadAudioStatus = useSelector(state => state.AIAudioGenerator.uploadAudioStatus);

    const vocalAudioInfo = useSelector(state => state.AIAudioGenerator.vocalAudioInfo);
    const uploadVocalAudioStatus = useSelector(state => state.AIAudioGenerator.uploadVocalAudioStatus);

    const incidentalAudioInfo = useSelector(state => state.AIAudioGenerator.incidentalAudioInfo);
    const uploadIncidentalAudioStatus = useSelector(state => state.AIAudioGenerator.uploadIncidentalAudioStatus);

    const lyricContent = useSelector(state => state.AIAudioGenerator.lyricContent);
    const lyricDesc = useSelector(state => state.AIAudioGenerator.lyricDesc);

    const isGenerateLyricsLoading = useSelector(state => state.AIAudioGenerator.isGenerateLyricsLoading);

    const isDraggingFile = useSelector(state => state.common.isDraggingFile);

    const isDraggingVoiceFile = useSelector(state => state.AIAudioGenerator.isDraggingVoiceFile);

    const prompt = useSelector(state => state.AIAudioGenerator.prompt);

    useEffect(() => {
        dispatch(FJActionAIAudioGenerator.initAIAudioGeneratorAction());
    }, [dispatch]);

    const setIsDraggingVoiceFile = useCallback(
        value => {
            dispatch(setSliceIsDraggingVoiceFile(value));
        },
        [dispatch],
    );

    const setIsDraggingFile = useCallback(
        value => {
            dispatch(setSliceIsDraggingFileAction(value));
        },
        [dispatch],
    );

    const onGenerate = useCallback(() => {
        dispatch(FJActionAIAudioGenerator.onGenerateAction());
    }, [dispatch]);

    const uploadAudioFile = file => {
        dispatch(FJActionAIAudioGenerator.uploadAudioFileAction(file));
    };

    const uploadVocalAudioFile = file => {
        dispatch(FJActionAIAudioGenerator.uploadVocalAudioFileAction(file));
    };

    const uploadIncidentalAudioFile = file => {
        dispatch(FJActionAIAudioGenerator.uploadIncidentalAudioFileAction(file));
    };

    const onLyricContentChange = value => {
        dispatch(FJActionAIAudioGenerator.onLyricContentChangeAction(value));
    };

    const onLyricDescChange = value => {
        dispatch(FJActionAIAudioGenerator.onLyricDescChangeAction(value));
    };

    const clearAudioInfo = () => {
        dispatch(FJActionAIAudioGenerator.clearAudioInfoAction());
    };

    const clearVocalAudioInfo = () => {
        dispatch(FJActionAIAudioGenerator.clearVocalAudioInfoAction());
    };

    const clearIncidentalAudioInfo = () => {
        dispatch(FJActionAIAudioGenerator.clearIncidentalAudioInfoAction());
    };

    const generateLyrics = () => {
        dispatch(FJActionAIAudioGenerator.generateLyricAction());
    };

    const onRecordClick = () => {
        FJAudioPlayManager.pauseAll();
        dispatch(FJActionModal.showRecordModalAction());
    };

    const onUseSampleInIncidentalFile = () => {
        dispatch(FJActionAIAudioGenerator.onUseSampleInIncidentalFileAction());
    };

    const onUseSampleInAudioFile = () => {
        dispatch(FJActionAIAudioGenerator.onUseSampleInAudioFileAction());
    };

    const onUseSampleInVoiceFile = () => {
        dispatch(FJActionAIAudioGenerator.onUseSampleInVoiceFileAction());
    };

    const getInspire = () => {
        dispatch(FJActionAIAudioGenerator.getInspireAction());
    };

    const onChangePrompt = value => {
        dispatch(FJActionAIAudioGenerator.changePromptAction(value));
    };

    const openMediaLibrary = type => {
        window.mediaLibraryOptions = {
            audioAddType: type,
        };
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };

    return (
        <FJAIAudioLeft
            tabIndex={tabIndex}
            onGenerate={onGenerate}
            taskStatus={taskStatus}
            isProjectLoading={isProjectLoading}
            freeNumCreation={freeNumCreation}
            creditNumber={creditNumber}
            uploadAudioFile={uploadAudioFile}
            audioInfo={audioInfo}
            uploadAudioStatus={uploadAudioStatus}
            vocalAudioInfo={vocalAudioInfo}
            uploadVocalAudioStatus={uploadVocalAudioStatus}
            uploadVocalAudioFile={uploadVocalAudioFile}
            onLyricContentChange={onLyricContentChange}
            lyricContent={lyricContent}
            lyricDesc={lyricDesc}
            onLyricDescChange={onLyricDescChange}
            clearAudioInfo={clearAudioInfo}
            clearVocalAudioInfo={clearVocalAudioInfo}
            clearIncidentalAudioInfo={clearIncidentalAudioInfo}
            uploadIncidentalAudioFile={uploadIncidentalAudioFile}
            incidentalAudioInfo={incidentalAudioInfo}
            uploadIncidentalAudioStatus={uploadIncidentalAudioStatus}
            generateLyrics={generateLyrics}
            isGenerateLyricsLoading={isGenerateLyricsLoading}
            isDraggingFile={isDraggingFile}
            setIsDraggingFile={setIsDraggingFile}
            onRecordClick={onRecordClick}
            isDraggingVoiceFile={isDraggingVoiceFile}
            setIsDraggingVoiceFile={setIsDraggingVoiceFile}
            onUseSampleInIncidentalFile={onUseSampleInIncidentalFile}
            onUseSampleInAudioFile={onUseSampleInAudioFile}
            onUseSampleInVoiceFile={onUseSampleInVoiceFile}
            getInspire={getInspire}
            prompt={prompt}
            onChangePrompt={onChangePrompt}
            openMediaLibraryByIncidentalAudio={() => {
                openMediaLibrary('incidentalAudio');
            }}
            openMediaLibraryByAudio={() => {
                openMediaLibrary('music');
            }}
            openMediaLibraryByVocalAudio={() => {
                openMediaLibrary('vocal');
            }}
        />
    );
};
export default FJAIAudioLeftContainer;
